import React, { forwardRef, ReactNode } from 'react';
import Button from '../Button/Button';
import classes from './SpinButton.module.css';

interface SpinButtonProps {
  onClick: () => void;
  children: ReactNode;
  className?: string;
}

const SpinButton = forwardRef<HTMLButtonElement, SpinButtonProps>(
  ({ onClick, children, className }, ref) => (
    <Button
      ref={ref}
      type="button"
      className={`${classes.btn}${className ? ` ${className}` : ''}`}
      onClick={onClick}
    >
      {children}
    </Button>
  )
);

SpinButton.displayName = 'SpinButton';

export default SpinButton;
